import type { Weight } from 'types'
const convertWeight = (value: number): Weight => ({
  lb: parseFloat((value / 16).toFixed(1)),
  kg: parseFloat((value / 35.274).toFixed(1)),
})

export default convertWeight
